// MUI components
import { styled } from '@mui/material/styles';
import { Typography } from '@mui/material';

export const WrapperDiv = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  flex: 1,
  height: '100%',
});

export const IconWrapper = styled(Typography)({
  width: 70,
  height: 70,
  borderRadius: '50%',
  background: '#ECEFF1',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginBottom: 10,
  '& svg': {
    fontSize: 32,
    color: '#607D8B',
  },
});

export const NoResultsTitle = styled(Typography)({
  fontSize: '18px',
  fontWeight: '700',
  lineHeight: '16px',
  textAlign: 'center',
  color: '#212121',
  margin: '8px 0px',
});

export const NoResultsDescriptionWrapper = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
});

export const NoResultsDescription = styled(Typography)({
  fontSize: '13px',
  fontWeight: '500',
  lineHeight: '21.86px',
  textAlign: 'center',
  color: '#37474F',
});
